import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FacebookOutlined, InstagramOutlined } from '@ant-design/icons';
import styles from './style.module.css';

const { Text } = Typography;

// Юридические документы лежат статикой в public/legal и открываются как PDF.
const LEGAL_DOCS: Record<string, { terms: string; privacy: string }> = {
  en: { terms: '/legal/terms-en.pdf', privacy: '/legal/privacy-en.pdf' },
  ru: { terms: '/legal/terms-ru.pdf', privacy: '/legal/privacy-ru.pdf' },
  pt: { terms: '/legal/terms-pt.pdf', privacy: '/legal/privacy-pt.pdf' },
};

const COMPLAINTS_BOOK = 'https://www.livroreclamacoes.pt/Inicio/';
const WHATSAPP_DISPLAY = '+351 911 540 083';
const WHATSAPP_LINK = 'https://wa.me/351911540083';
const EMAIL = 'Algarvequest@gmail.com';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();

  const lang = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  const docs = LEGAL_DOCS[lang] || LEGAL_DOCS.en;

  return (
    <footer className={styles.outer}>
      <div className={styles.wrapper}>
        <div className={styles.column}>
          <Text className={styles.brand}>Algarve Quest</Text>
          <nav className={styles.links} aria-label="Legal">
            <a href={docs.terms} target="_blank" rel="noopener noreferrer" className={styles.link}>
              {t('footer.terms')}
            </a>
            <a href={docs.privacy} target="_blank" rel="noopener noreferrer" className={styles.link}>
              {t('footer.privacy')}
            </a>
            <a href={COMPLAINTS_BOOK} target="_blank" rel="noopener noreferrer" className={styles.link}>
              {t('footer.complaints')}
            </a>
          </nav>
        </div>

        <div className={styles.column}>
          <Text className={styles.contactLine}>
            WhatsApp:{' '}
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className={styles.link}>
              {WHATSAPP_DISPLAY}
            </a>
          </Text>
          <Text className={styles.note}>{t('footer.whatsappNote')}</Text>

          <Text className={styles.contactLine}>
            Email:{' '}
            <a href={`mailto:${EMAIL}`} className={styles.link}>
              {EMAIL}
            </a>
          </Text>

          <div className={styles.social}>
            <a
              href="https://www.instagram.com/algarve_quest"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
              title="Instagram"
            >
              <InstagramOutlined style={{ fontSize: '20px' }} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61550092716283"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
              title="Facebook"
            >
              <FacebookOutlined style={{ fontSize: '20px' }} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
